import React, { FC } from 'react';
import ReactDOM from 'react-dom/client';

import r2wc from 'react-to-webcomponent';

import { PdfComponent } from '@distribute/frontend/ui/pdf-component';

type Props = {
  url: string;
  name: string;
  width?: number;
  height?: number;
  align: string;
  origin: string;
};

export const PdfWebComponent: FC<Props> = ({
  url,
  name,
  width,
  height,
  align,
  origin,
}) => {
  return (
    <PdfComponent
      fileUrl={url}
      fileName={name}
      mediaWidth={width}
      mediaHeight={height}
      align={align || 'center'}
      origin={origin}
    />
  );
};

customElements.define(
  'pdf-component',
  r2wc(PdfWebComponent, React, ReactDOM, {
    props: {
      url: 'string',
      name: 'string',
      width: 'number',
      height: 'number',
      align: 'string',
      origin: 'string',
    },
  })
);
